import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type VitalsTimerPayload = {
  encounterId: string;
};

function usePauseVitalTimer(encounterId: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["pauseVitalsTimer"],
    (payload: VitalsTimerPayload) => {
      return axiosChartInstance.post<{ encounterId: string }>(
        `v1/Vitals/${encounterId}/timer-control/pause`,
        payload
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vitalsTimer", { encounterId }]);
      },
    }
  );
}

export { usePauseVitalTimer };
